module.exports = __webpack_public_path__ + "img/dashboard_blue.5c8d5f9a.svg";